import { Link, useMatch, useResolvedPath } from "react-router-dom";



function BtnLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
  
    return (
      <div className="py-2">
        <Link
          style={{ textDecoration : "none" , backgroundColor: "rgb(185, 9, 180)" , padding: "8px 18px", borderRadius: "5px", color : match? "yellow" : "white"}
        
        
        
        }
          to={to}
          {...props}
        >
          {children}
        </Link>
       
      </div>
    );
  }
  export default BtnLink